<template>
  <section>
    <products-list v-if="products"></products-list>
  </section>
</template>

<script>
import ProductsList from "./ProductsList";
import { getProducts, getProductsByFiletype } from "./ProductsActions";

export default {
  components: {
    ProductsList
  },
  vuex: {
    getters: {
      products: state => state.products,
      isArchive: state => state.isArchive
    },
    actions: { getProducts, getProductsByFiletype }
  },
  methods: {
    fetch () {
      if (this.$route.params.id !== "null") {
        this.getProducts(this.$route.params.id, this.$route.params.fileTypeId, this.isArchive);
      } else {
        this.getProductsByFiletype(this.$route.params.fileTypeId, this.isArchive);
      }
    }
  },
  route: {
    data ({ to: { params: { id, fileTypeId } } }) {
      this.fetch();
    }
  },
  watch: {
    "isArchive": function (value) {
      console.log("Archive changed");
      this.fetch();
    }
  }
};
</script>



// WEBPACK FOOTER //
// Products.vue?2ce80836